module.exports = __webpack_public_path__ + "static/media/icon_delete_white.0a1633b8.svg";